export { personalHomeRoute } from './route';

export const loadPersonalHomePage = async () => {
    const { PersonalHomePage } = await import('./PersonalHomePage');

    return { Component: PersonalHomePage };
};
